/**
 * Created by lenovo on 2017/4/21.
 */
import React,{Component} from 'react'
import {Link} from 'react-router'
import {language,getUserId,resultTip} from 'UTIL/common'
const returnJson =(map) =>{
    const json = [];
    for(var key in map)
    {
        const arr = {"id":key,"name":map[key]};
        json.push(arr);
    }
    const data = json.map(function (str,index) {
        return <option value={str.id} key={index}>{str.name}</option>
    });
    return data;
};
export default class FormSelect extends Component{
    render(){
        const options = returnJson(this.props.data);
        return (
            <div className="row form-group">
                <label  className="multi-label control-label col-xs-2">{language()[this.props.name]}</label>
                <div className="col-xs-3">
                    <select  className="form-control" id={this.props.id}>
                        {options}
                    </select>
                </div>
            </div>
        )
    }
}
//<FormSelect id="" name="" data="" />传入的data值是map类型


// WEBPACK FOOTER //
// ./modules/component/form/formSelectSimple.js